var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M-661.334,92.381a6,6,0,0,0-6,6,6,6,0,0,0,6,6,6,6,0,0,0,6-6A6,6,0,0,0-661.334,92.381Zm2.359,7.833a.372.372,0,0,1,0,.526.372.372,0,0,1-.526,0l-1.833-1.833-1.833,1.833a.372.372,0,0,1-.526,0,.372.372,0,0,1,0-.526l1.833-1.834-1.833-1.833a.372.372,0,0,1,0-.526.372.372,0,0,1,.526,0l1.833,1.833,1.834-1.833a.372.372,0,0,1,.526,0,.372.372,0,0,1,0,.526h0l-1.833,1.834Z",
    transform: "translate(667.834 -91.881)",
    fill: "#8896a3",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyX);
export default __webpack_public_path__ + "static/media/GreyX.7258538e.svg";
export { ForwardRef as ReactComponent };